// extracted by mini-css-extract-plugin
module.exports = {"modal":"product-ui-modal_modal__MeOpS","modalHeader":"product-ui-modal_modalHeader__dMek6","absolutePositioned":"product-ui-modal_absolutePositioned__nMZzm"};